export default () => {
    const videoBoxPlay = document.querySelectorAll('.video-main');
    videoBoxPlay.forEach(btnPlay => {
        const videoBox = btnPlay.querySelector('.video-main__video');
        btnPlay.addEventListener('click', () => {
            if (btnPlay.classList.contains('play')) {
                btnPlay.classList.remove('play');
                videoBox.classList.remove('play');
                videoBox.pause();
                videoBox.controls = false;
                btnPlay.querySelector('.video-main__play').classList.remove('play');
            } else {
                btnPlay.classList.add('play');
                videoBox.classList.add('play');
                videoBox.play();
                videoBox.controls = true;
                btnPlay.querySelector('.video-main__play').classList.add('play');
            }
        })
        // if (videoBox.play == true) {
        //     console.log("play");
        // }
    });
    
};
